import { PropertyType as PT, sortByName } from '../../../common';

export const mapEntityToApi = (data: PT): PT => ({
	sid: data.token,
	partners: data.activePartners,
});

export const mapApiToEntity = (data: PT[]): PT[] => {
	return sortByName(data, 'name').map((u: PT) => ({
		label: u.name,
		value: u.id,
	}));
};
